import React from 'react';
import ContentBuilder from '../../core/ContentBuilder';
import { mergeClassNames } from '../../utils/mergeClassNames';
import { Link } from './Link';
import styles from './PrizeItem.module.scss';

interface PrizeItemProps
{
  data: {
    category: string,
    title: string,
    name: string,
    description: string,
    coverImage: {src: string},
    image: {src: string},
    detailURL: string,
    icon?: string,
		button?: {
			label: string,
			url: string,
		}
  }
}

export class PrizeItem extends React.Component<PrizeItemProps>
{
  render()
  {
    return (
      <div className={styles['container']}>
        <h3>{this.props.data['category']}</h3>
        <div className={styles['cover']}>
          <img src={this.props.data['coverImage']?.['src']} />
        </div>
        <div>
          <div className={styles['head']}>
            {this.props.data.icon?(
              <div className={styles['icon']}>
                <img src={`assets/awards/winners/icons/${this.props.data.icon}.png`} />
              </div>
            ):null
            }
            <div>
              <h4>{this.props.data['title']}</h4>
              <h5>{this.props.data['name']}</h5>
            </div>

          </div>
          <div className={styles['description']}>
            <div className={styles['text']}>
              <div>{ContentBuilder.build(this.props.data['description'])}</div>
              {
                (this.props.data['detailURL'])?(<Link decoration={false} arrow={false} href={this.props.data['detailURL']} className={[styles['button'], 'round', 'theme-purple', 'small'].join(' ')}>発表資料</Link>):null
              }
							{
								(this.props.data['button'] && this.props.data['button']['label'] && this.props.data['button']['label'].length > 0)?(
									<div className={styles['materials']}>
										<Link decoration={false} arrow={false} className={mergeClassNames(['round', 'theme-purple', 'white', 'small'])} target='_blank' href={this.props.data['button']['url']}>{this.props.data['button']['label']}</Link>
									</div>
								):null
							}
            </div>
            <div className={styles['image']}>
              <img src={this.props.data['image']?.['src']} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}